export const getROPList = state => state?.businessSignUp?.ropList;
